<app-loading-spinner *ngIf="!((assetDetail | keyvalue)?.length) else assetDetailsPage">
</app-loading-spinner>

<ng-template #assetDetailsPage>
<section class="assetsectiondetails" id="box">
  <app-banner
  [image]="image"
  [bannerTitle]="bannerTitle"
  [additionalStyles]="{ height: '21vh'}" 
  [bannerTextStyles]="{ left: '7vw', top: '7vw' }"
></app-banner>
<div class="row assetdetails">
  <div class="col-sm-12 col-md-8 col-lg-9 backtoassets">
    <a (click)="navigateBack()" style="cursor: pointer;">
      <div class="back-icon-row" style="font-size: 20px">
        <span class="uil-dl-icon-Arrow-left uil-color-primary back-icon"></span>
        <span class="backtoassetstext">Back</span>
      </div>
      </a>
  </div>
  <div class="col-sm-12 col-md-4 col-lg-3 last-update-container">
    <div class="lastupdatedate">Last Update: {{assetDetail.Updated_On | date : 'dd MMM yyyy'}}</div>
  </div>

  <div class="col-sm-12 col-md-8" acnScrollDetectSpy scrollContainer="window" [spyItems]="['overview', 'resourcesAndLinks', 'contributors', 'reviews']"
  (sectionChange)="onSectionChange($event)">
    <div class="asset-details-section">
      
        <div class="row section-margin-bottom asset-title">
          <div class="row overview-title">{{assetDetail.Asset_Name }}</div>
          <div class="row">
            <a class="view-btn">View</a>
            <span class="views-count" title="View count">{{ assetDetail.View_Count }}</span>
            

            <div class="star-section" [title]="'Average Rating: ' + assetDetail.Average_Rating">
              <span *ngFor="let in of filledRatingStars">
                <span class="fa fa-star star-icon filled-star-color"></span>
              </span>

              <span *ngFor="let in of unfilledRatingStars">
                <span class="fa fa-star-o star-icon unfilled-star-color"></span>
              </span>
            </div>

            <span class="ratings-count" title="Rate count">{{ assetDetail.User_Rating_Count }}</span>
          </div>
        </div>
      <!-- Start of Overview Section-->
      <div id="overview" class="row section-margin-bottom">
        <div class="row overview-title">Overview</div>
        <app-overview [overviewList]="overviewList"></app-overview>
      </div>
      <!--End of Overview Section-->

      <!-- Start of Resources and Links Section-->
      <div id="resourcesAndLinks" class="row section-margin-bottom">
        <div class="row overview-title">
          Resources and Links
        </div>
        <app-resources-links class="use-complete-row"
          [resourcesList]="this.assetDetail.Resources"
          [assetName]="assetDetail.Asset_Name"
        ></app-resources-links>
      </div>
      <!--End of Resources and Links Section-->

      <!-- Start of Contributors Section-->
      <div id="contributors" class="row section-margin-bottom">
        <div class="row overview-title">Contributors</div>
        <div class="col-md-12">
        <app-contributors
          [contributorList]="this.assetDetail.Contributors"
        ></app-contributors>
        </div>
      </div>
      <!--End of Contributors Section-->

      <!-- Start of Reviews Section-->
      <div id="reviews" class="row section-margin-bottom">
        <div class="row overview-title">Reviews</div>
        <div class="col-sm-12 col-md-12 col-lg-12 no-padding">
          <app-asset-reviews
            [commentList]="assetDetail.Comments"
            [totalRatingSum]="totalRatingSum"
            [avg_rating]="assetDetail.Average_Rating"
            [ratingList]="ratingList"
            [filledRatingStars] = "filledRatingStars"
            [unfilledRatingStars] = "unfilledRatingStars"
          ></app-asset-reviews>
        </div>
      </div>
    </div>
    <!-- End of Reviews Section-->

    <!-- RELATED ASSETS AND CONTACTS SECTION COMMENTED FOR NOW AS NO DATA AVAILBALE FOR IT.
    UNCOMMENT BELOW CODE WHEN REQUIRED.-->

    <!--       <div class="row section-margin-bottom">
            <div id="overview" class="row overview-title">Related Assets</div>
            <div class="col-md-4" *ngFor="let data of assetList" style="padding-left: 0px; padding-right: 0px">
            <app-asset-card [card]="data"></app-asset-card>
            </div>
        </div>
              
        <div class="row section-margin-bottom">
            <div id="overview" class="row overview-title">Contacts</div>
            <app-contact-card [contactData]="contactList"></app-contact-card>
        </div>
        
    -->
  </div>
  <div class="col-sm-12 col-md-4 lastupdate">
    <app-rating-modal [assetDetail] = "assetDetail"></app-rating-modal>
    <app-request-access-modal [assetName]="assetDetail.Asset_Name" [accessCodePresent]= "accessCodePresent" ></app-request-access-modal>
    <div class="icon-inpage-section" id="lastupdate">
    <div class="row right-icons-margin">
      <div class="col-md-4 col-lg-2 icon-container" style="text-align: center">
        <div
          class="uil-font-icon right-icons-font"
        >
        <span data-toggle="modal"
          data-target="#myModal" 
          class="fa cursorPointer" [ngClass]="{
          'fa-star': assetDetail.User_Rated_Flag,
          'fa-star-o': !assetDetail.User_Rated_Flag,
          'filled-star-color': assetDetail.User_Rated_Flag
        }" title="Rate this Asset"></span>
        </div>
        <div data-toggle="modal"
        data-target="#myModal" 
        class="right-icons-label cursorPointer" title="Rate this Asset">Rate </div>
      </div>
      <div class="col-md-4 col-lg-2 icon-container" style="text-align: center">
        <div class="uil-font-icon right-icons-font cursorPointer" title="Share this Asset">
          <span (click)="ShareAssetonOutlook()" class="uil-dl-icon-Share-android uil-color-secondary"></span>
        </div>
        <div (click)="ShareAssetonOutlook()" class="right-icons-label cursorPointer" title="Share this Asset">Share</div>
      </div>
      <div class="col-md-4 col-lg-2 icon-container" style="text-align: center">
        <div class="uil-font-icon right-icons-font" [title]="assetDetail.User_BookMarked_Assets? 'Remove from My Bookmarks' : 'Add to My Bookmarks'">
          <span
            class="fa cursorPointer paddingLeft"
            [ngClass]="{
              'fa-bookmark': assetDetail.User_BookMarked_Assets,
              'fa-bookmark-o': !assetDetail.User_BookMarked_Assets,
              'bookmark-icon': assetDetail.User_BookMarked_Assets
            }"
            style="cursor: pointer;"
            (click)="onBookmarkClick()"
          ></span>
        </div>
        <div class="right-icons-label cursorPointer">Bookmark</div>
      </div>
    </div>

      <div
        class="uil-align-with-content uil-in-page-navigation on-scrollbar scroll-in-page in-page-navigation">
        <div class="uil-in-page-navigation-column uil-dynamic-scrollbar">
          <ul class="uil-single-row-list">
            <li class="cursorPointer"
             *ngFor = "let pageSect of pageSections" [ngClass]="{active : pageSect.active}">
              <a pageScroll (click)="scrollTo(pageSect.linkHash)">{{pageSect.linkTitle}}</a>
            </li>
          </ul>
        </div>
   
        <!-- <div class="uil-curtain active">
          <div
            class="
              uil-curtain-panel
              uil-curtain-panel-right
              uil-curtain-open-100
              uil-curtain-close-0
              active
            "
            style="top: 0px"
          >
            <div class="uil-curtain-open on-scrollbar">
              <button
                class="
                  uil-curtain-toggle
                  uil-link-icon
                  uil-curtain-toggle-button-default
                "
                type="button"
              >
                <span class="uil-in-page-navigation-toggle-icon"></span>
              </button>
              <div class="uil-curtain-panel-content" style="float: left">
                <ul class="uil-single-row-list">
                  <li class="">
                    <a href="assetdetails#overview">Overview</a>
                  </li>
                  <li class="">
                    <a href="assetdetails#resourcesAndLinks"
                      >Resources and Links</a
                    >
                  </li>
                  <li class="">
                    <a href="assetdetails#contributors">Contributors</a>
                  </li>
                  <li class="">
                    <a href="assetdetails#reviews">Reviews</a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="uil-curtain-close">
              <button
                class="
                  uil-curtain-toggle
                  uil-link-icon
                  uil-curtain-toggle-button-default
                "
                type="button"
              >
                <span class="uil-in-page-navigation-toggle-icon"></span>
              </button>
            </div>
          </div>
        </div> -->
      </div>
      </div>
  </div>
</div>
</section>
</ng-template>